import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { LookupCategory } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LookupCategoryService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

    public getAllLookupCategories(lookupCategorySearchParam:IGlobalSearchParam):Observable<any> {
      console.log(lookupCategorySearchParam);
      return this.apiService.post(`LookupCategory/SearchLookupCategory`,lookupCategorySearchParam)
    }



    
      /**
      * This method is used to get individual lookup master record based on the lookupid
      *
      * @param  categoryId  
      * @return      json result
      */
       public getLookupCategoryById(categoryId:number):Observable<any> {
        return this.apiService.get(`LookupCategory/${categoryId}`)
    }

    /**
    * This method is used to post/add new lookup master record
    *
    * @param  LookupCategory object which contains the lookup record values
    * @return      json result
    */
     public postLookupCategory(lookupMaster:LookupCategory):Observable<any> {
       console.log(lookupMaster);
        return this.apiService.post(`LookupCategory`, lookupMaster)
    }


    /**
    * This method is used to update the existing lookup master record
    *
    * @param  Category Id 
    * @param  LookupCategory object which contains the lookup record values
    * @return      json result
    */
     public updateLookupCategory(categoryId:number, lookupMaster:LookupCategory):Observable<any> {
        return this.apiService.put(`LookupCategory/${categoryId}`, lookupMaster)
    }


    /**
    * This method is used to delete the existing lookup master record
    *
    * @param  Category Id
    * @return      json result
    */
     public deleteLookupCategory(categoryId:number):Observable<any> {
        return this.apiService.delete(`LookupCategory/${categoryId}`)
    }

    public ExportLookupCategory(lookupMasterSearchParam:IGlobalSearchParam):Observable<any> {
      return this.http.post(`${environment.apiRoot}LookupCategory/ExportLookupCategory`, lookupMasterSearchParam,
      {  
          responseType: 'blob',
          observe: 'response'
       });
    }






}
